module.exports = __webpack_public_path__ + "media/images/lb/695-ba2894bf1c0dccb7256128736f767010.svg";